import { API_ROUTES } from '@/api/apiRoutes';
import { safeAxios } from '@/services/safeAxios';
import { log } from '@/logger/logger';
import type { ApiObject } from '@/types/analytics.types';

const logger = log.getLogger('WeavyAnalytics');

// Weavy Analytics - Custom BI events implementation
class WeavyAnalytics {
  async track(event: string, properties: ApiObject | null): Promise<void> {
    try {
      await safeAxios.post(API_ROUTES.bi.track(), {
        eventName: event,
        properties: properties || {},
      });
    } catch (error) {
      logger.error('Failed to track event:', error);
    }
  }

  async identify(): Promise<void> {
    try {
      await safeAxios.post(API_ROUTES.bi.identify());
    } catch (error) {
      logger.error('Failed to identify user:', error);
    }
  }
}

const weavyAnalytics = new WeavyAnalytics();

export { weavyAnalytics };
